
import { createApp } from 'vue'
import App from './index.vue'
import router from './router'

createApp(App).use(router).mount('#app')
